/**
 * Created by or_p on 6/18/2016.
 */
import React, { Component } from 'react';
import BaseElementDialog from '../BaseElementDialog/BaseElementDialog';
import * as Colors from 'material-ui/styles/colors';
import Tab from './Tab';
import TabIndex from './TabIndex';
import _ from 'lodash';
import RaisedButton from 'material-ui/RaisedButton';
import ReactDOM from 'react-dom';
import {TweenMax} from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import FlipMove from 'react-flip-move';
import ElementDialogWrapper from '../ElementDialogWrapper/ElementDialogWrapper';
import { getChildElementPreset } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { elementTypes } from 'crazyEditor/components/Elements/index';
import { getSelectedElements, getAllVisibleElementsForView, getElementsForView } from 'crazyEditor/redux/modules/element/elementSelectors';
import { connect } from 'react-redux';
/* global Strong Linear SlowMo Ease TimelineMax */

const styles = {
  listsContainer: {
    marginTop: 30,
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    flexDirection: 'row',
    width: 750,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  addTab: {
    alignSelf: 'flex-start',
    marginTop: 10,
    marginBottom: 50,
  },
};
@connect(
  state => ({
    elements: getElementsForView(state)
  })
)
export default class TabsDialog extends Component {
  constructor(props) {
    super(props);

    this.getElementProps = this.getElementProps.bind(this);
  }

  componentWillMount(props) {
    let selectedElement = this.props.selectedElement;
    if (props) {
      selectedElement = props.selectedElement;
    }
    this.setState({
      tabs: _.get(selectedElement, 'data.tabNames', []).map((title, index) => {
        return {id: this._nextTabId++, title, childId: _.get(selectedElement, `data.children[${index}].id`)};
      })
    });
  }

  componentWillReceiveProps(nextProps) {
    const selectedElement = this.state;
    if (selectedElement !== nextProps.selectedElement) {
      this.componentWillMount(nextProps);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.tabs.length < this.state.tabs.length) {
      _.defer(() => {
        const list = ReactDOM.findDOMNode(this.refs.baseElementDialog.refs.content);
        TweenMax.to(list, 4, {scrollTo: {y: list.scrollHeight}, ease: Ease.easeInOut});
      });
    }
  }

  getElementProps(newElement, selectedElement, elements) {
    const tabNames = [];
    const children = [];
    _.forEach(this.state.tabs, (tab) => {
      tabNames.push(tab.title);
      children.push(getChildElementPreset(elementTypes.TabsElement));
    });
    if (!newElement) {
      _.forEach(this.state.tabs, (tab, index) => {
        children[index] = elements[tab.childId] || children[index];
      });
    }
    return {
      data: {
        tabNames,
        children
      }
    };
  }

  removeTab = (index) => {
    const tabs = _.clone(this.state.tabs);
    tabs.splice(index, 1);
    this.setState({tabs});
  };

  addTab = () => {
    const {tabs} = this.state;
    this.setState({tabs: tabs.concat({id: this._nextTabId++, title: null})});
  };

  moveTab = (fromIndex, toIndex) => {
    if (!this.state.flipingInProgress) {
      const tabs = _.clone(this.state.tabs);
      tabs[fromIndex] = this.state.tabs[toIndex];
      tabs[toIndex] = this.state.tabs[fromIndex];
      this.setState({tabs});
    }
  };

  updateTab = (index, value) => {
    const tabs = _.clone(this.state.tabs);
    tabs[index].title = value;
    this.setState({tabs});
  };

  _nextTabId = 0;

  render() {
    const {open, newElement, onCancel, onAddUpdate, selectedElement, elements} = this.props;
    const {tabs} = this.state;
    return (
      <BaseElementDialog
        open={open}
        newElement={newElement}
        title={`${newElement ? 'Add' : 'Edit'} Tabs`}
        ref="baseElementDialog"
        inputValid={!_.isEmpty(tabs)}
        onCancel={() => onCancel()}
        onAddUpdate={() => onAddUpdate(this.getElementProps(newElement, selectedElement, elements))}
      >
        <div style={styles.listsContainer}>
          <div style={styles.list}>
            {tabs.map((tab, index) => {
              return (
                <TabIndex
                  key={index}
                  index={index}
                />
              );
            })}
          </div>
          <FlipMove
            style={{...styles.list, flexGrow: 1}}
            enterAnimation="accordianVertical"
            leaveAnimation="accordianVertical"
            onStart={() => {this.state.flipingInProgress = true;}}
            onFinishAll={() => {this.setState({flipingInProgress: false});}}
          >
            {tabs.map((tab, index) => {
              const {title, id} = tab;
              return (
                <Tab
                  id={id}
                  index={index}
                  title={title}
                  onDelete={() => {this.removeTab(index);}}
                  key={id}
                  moveTab={this.moveTab}
                  onChange={(value) => {this.updateTab(index, value);}}
                  onBeginDrag={this.onBeginDrag}
                  onEndDrag={this.onEndDrag}
                />
              );
            })}
            <RaisedButton
              style={styles.addTab}
              label="add new tab"
              onClick={this.addTab}
            />
          </FlipMove>
        </div>
      </BaseElementDialog>);
  }
}
